<div class="min-h-screen flex flex-column align-items-center justify-content-center surface-0 text-900 px-4 py-6">
    <img src="../../assets/images/full-logo.png"  height="70" alt="logo" class="mb-5" />
    <h1 class="text-3xl  m-0 mb-3 text-center">Access Not Authorized</h1>
    <p class="text-600 line-height-3 m-0 mb-2 max-w-30rem text-center text-lg">
        You signed in successfully, but you don’t currently have permission to access this application.
    </p>
    <p class="text-600 line-height-3 m-0 mb-5 max-w-30rem text-center text-lg">
        Please contact your administrator to request access.
    </p>
    <div class="flex gap-2 flex-wrap justify-content-center">
        <button pButton type="button" label="Try Again" (click)="retry()"></button>
        <button pButton type="button" class="p-button-outlined" label="Sign Out" (click)="authService.logout()"></button>
    </div>
</div>
